import React from "react";
import { RevealHeading, StaggerReveal } from "./Motion";
import { Squiggle } from "./Decorations";

const PHASES = [
    { phase: "Phase 01", title: "MVP", color: "#FF5B3E", points: ["Bengali TTS engine", "Embed widget v1", "Free tier", "Live in 5 portals"], date: "Q1 2026" },
    { phase: "Phase 02", title: "Polish", color: "#3D5BFF", points: ["3 → 8 voices", "Pronunciation editor", "Listener analytics v2", "WordPress plugin"], date: "Q2 2026" },
    { phase: "Phase 03", title: "Integration", color: "#2EE8B5", points: ["REST API + webhooks", "CMS connectors (Joomla, Drupal)", "SSO for newsrooms", "Mobile SDK"], date: "Q3 2026" },
    { phase: "Phase 04", title: "Scale", color: "#FFD23F", points: ["Audio ad network launch", "Programmatic SSP integrations", "Revenue share dashboard", "100+ portals"], date: "Q4 2026" },
    { phase: "Phase 05", title: "Expand", color: "#7B3FE4", points: ["Hindi + Urdu support", "West Bengal market push", "Voice cloning", "Podcast distribution"], date: "2027" },
];

export const Roadmap = () => {
    return (
        <section className="relative py-24 lg:py-32 overflow-hidden">
            <Squiggle color="#FF4FA3" className="absolute top-10 left-[8%] w-24 animate-float-slow"/>
            <div className="relative">
                <div className="mx-auto max-w-[1240px] px-5 sm:px-8 mb-12 lg:mb-16">
                    <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-coral mb-5">What's next</p>
                    <RevealHeading as="h2" className="h-display text-[44px] sm:text-[60px] lg:text-[80px] text-ink max-w-[820px]">
                        The roadmap, <span className="italic-display text-coral">in public.</span>
                    </RevealHeading>
                </div>

                <StaggerReveal className="overflow-x-auto no-scrollbar pb-8 lg:pb-10">
                    <div className="flex gap-5 lg:gap-7 px-5 sm:px-8 lg:px-[max(2rem,calc((100%-1240px)/2+2rem))]" style={{ width: "max-content" }}>
                        {PHASES.map((p, i) => (
                            <div
                                data-stagger
                                data-testid={`roadmap-${i}`}
                                key={i}
                                className="w-[280px] sm:w-[320px] flex-shrink-0 bg-white rounded-3xl border border-cream-300 shadow-soft hover:shadow-soft-lg transition-all hover:-translate-y-1 hover:rotate-[-1deg] overflow-hidden"
                                style={{ transform: `rotate(${(i % 2 === 0 ? 0.7 : -0.7)}deg)` }}
                            >
                                <div className="h-2 w-full" style={{ background: p.color }}/>
                                <div className="p-7">
                                    <div className="flex items-center justify-between mb-4">
                                        <span className="text-[11px] uppercase tracking-[0.22em] font-semibold text-ink-muted">{p.phase}</span>
                                        <span className="text-[11px] font-mono text-ink-muted">{p.date}</span>
                                    </div>
                                    <h3 className="font-display text-[34px] font-semibold tracking-tight text-ink mb-5 leading-none">
                                        {p.title}
                                    </h3>
                                    <ul className="space-y-2.5">
                                        {p.points.map((pt, j) => (
                                            <li key={j} className="text-[14px] text-ink-muted flex gap-2">
                                                <span className="mt-2 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: p.color }}/>
                                                {pt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </StaggerReveal>
                <p className="text-center text-[12px] text-ink-muted mt-2 italic">← scroll →</p>
            </div>
        </section>
    );
};
